module.exports = __webpack_public_path__ + "img/video_editor.b899ea94.png";